<template>
  <div
    ref="pdf_download"
    class="bg-white w-full p-12"
    style="height: 1100px; width: 780px; position: relative"
  >
    <div class="flex justify-between items-center">
      <!-- <div style="max-width: 36vh;">
        <img
          v-if="quote.brand.img != ''"
          class="img-fluid"
          :src="quote.brand.img"
          alt=""
          :key="'QuoteBrandImg'+quote.id"
        />
        <img v-else class="img-fluid" src="/img/ejemplo.brand.png" alt="" />
      </div> -->
      <div style="max-width: 24vh;">
        <img
          class="img-fluid"
          :src="image_brand"
          alt=""
        />
      </div>
      <div class="w-auto text-sm">
        <a class="font-semibold" :href="`tel:${quote.brand.telephone}`"
          >Tel: {{ quote.brand.telephone }}</a
        ><br />
        <a class="font-semibold" :href="`mailto:${quote.brand.email}`"
          >Email: {{ quote.brand.email }}</a
        ><br />
        <a class="font-semibold" :href="quote.brand.url">{{
          quote.brand.url
        }}</a>
      </div>
    </div>
    <div class="mt-20 mb-6">
      <div class="flex justify-between items-center">
        <h1 class="text-5xl font-extrabold">Your Quote</h1>
        <p class="text-md w-auto font-semibold">{{ date(quote.created_at) }}</p>
      </div>

      <h3
        style="letter-spacing: 0.8px; border-radius:2rem"
        class="w-3/12 text-center font-extrabold border-2 border-black text-2xl py-2 px-1 mb-6 mt-8"
      >
        {{ quote.code }}
      </h3>

      <div class="mt-6">
        <p class="mb-8 font-bold text-md text-black">Dear {{ quote.name }},</p>
        <p class="mb-4 text-md">
          We are delighted to provide you with a quote for finance as per below.
        </p>
        <div class="my-6 text-gray-700">
          <div class="flex">
            <p class="font-bold pr-2 text-md">Type</p>
            <div v-if="quote.type == 'hire_purchase'">
              <p class="text-md font-bold">Hire purchase</p>
            </div>
            <div v-else>
              <p class="text-md font-bold">Lease</p>
            </div>
          </div>
          <!--Cost-->
          <div class="flex">
            <p class="font-bold pr-2 text-md">Cost</p>
            <div v-if="quote.type == 'hire_purchase'">
              <p v-if="quote.vat_deferal" class="text-md font-bold">
                £ {{ formatNumber(quote.cost) }} + VAT (£ {{ formatNumber(quote.vat)}})
              </p>
              <p v-else class="text-md font-bold">
                £ {{ formatNumber(quote.cost) }} + VAT (£ {{ formatNumber(quote.vat)}})
              </p>
            </div>
            <div v-else>
              <p class="text-md font-bold">
                £ {{ formatNumber(quote.cost)}} + VAT (£ {{ formatNumber(quote.vat)}})
              </p>
            </div>
          </div>

          <div v-if="quote.not_vat_items" class="flex">
                  <p class="font-bold pr-2 text-md">Not vat items:</p>
                  <p class="text-md font-bold"> £ {{ formatNumber(quote.not_vat_items) }}</p>
                </div>
                <div v-if="quote.not_vat_items" class="flex">
                  <p class="font-bold pr-2 text-md">Total Net:</p>
                  <p class="text-md font-bold"> £ {{ totalNetCost }}  + VAT (£ {{ formatNumber(quote.vat)}})</p>
                </div>

          <!--Deposit-->
          <div class="flex">
          <div>
            <p v-if="quote.deposit" class="font-bold pr-2 text-md">Deposit</p>
            <p v-else class="font-bold pr-2 text-md">No deposit</p>
          </div>
          <!--Lease Quote-->
            <div v-if="quote.deposit && quote.type == 'lease'">
              <p class="text-md font-bold">{{ quote.deposit ? "£ " + formatNumber(quote.deposit) + 
              " + VAT (£ "+ formatNumber(0.2*quote.deposit) +") " : '' }}
              </p>
            </div>
            <div v-else>
            <!--Hire Purchase Quote-->
              <!--VAT deferral-->
              
              <div v-if="quote.vat_deferal" class="text-md font-bold">
                <p>{{ quote.deposit != null ? "£ " + formatNumber(quote.deposit) : " " }}</p>
              </div>
              <!--No VAT deferral-->
              <div v-if="!quote.vat_deferal" class="text-md font-bold">
                <!--Net deposit-->
                
                <p class="text-md font-bold">
                  {{`£ ${formatNumber(parseFloat(quote.deposit) + parseFloat(quote.vat))} inc VAT`}}
                </p>
              </div>
            </div>
          </div>



          <!-- <div class="flex">
            <p v-if="quote.deposit != null || quote.type == 'hire_purchase'" class="font-bold pr-2 text-md">
              Deposit
            </p>
            <p v-else class="font-bold pr-2 text-md">No deposit</p>

            <div v-if="quote.type == 'hire_purchase'">
              <p v-if="quote.vat_deferal" class="text-md font-bold">
                {{
                  quote.deposit != null ? "£ " + formatNumber(quote.deposit) : " "
                }}
              </p>
              <p v-else class="text-md font-bold"> -->
                <!--net deposit-->
                <!-- <p v-if="quote.net_deposit" class="text-md font-bold">
                  {{ quote.deposit && (parseFloat(quote.deposit) > (quote.vat)) ? `£ ${formatNumber(parseFloat(quote.deposit))} inc VAT (£ ${formatNumber(quote.vat)})`
                    : `£ ${formatNumber(parseFloat(quote.vat))}`}}
                </p>
                <p v-else class="text-md font-bold">
                  {{
                    quote.deposit != null
                      ? `£ ${formatNumber(parseFloat(quote.deposit))} inc VAT (£ ${formatNumber(quote.vat)})` : `£ ${formatNumber(quote.vat)} inc VAT (£ ${formatNumber (quote.vat)})`  
                  }}
                </p> -->
              <!-- </p>
            </div>
            <div v-else> Deposit Lease-->
              <!-- <p class="text-md font-bold">
                {{
                  quote.deposit != null
                    ? "£ " + formatNumber(quote.deposit) + " + VAT (£ "+ formatNumber(0.2*quote.deposit) +") "
                    : ""
                }}
              </p>
            </div>
          </div>  -->







          <!--Quote terms-->
          <div class="flex" v-if="quote.type === 'hire_purchase'">
            <p class="font-bold pr-2 text-md">Approx</p>
            <p class="text-md font-bold">
              {{ quote.term + " x " + "£ " + formatNumber(quote.payment)}}
            </p>
            <p v-if="quote.balloon != null || quote.balloon > 0" class="font-bold pr-2 text-md">
              &nbsp;+ Balloon £ {{formatNumber(quote.balloon)}} included for month {{ quote.balloon_fall }}
            </p>
          </div>
          <div v-else-if="quote.vat_deferal" class="flex">
            <p class="font-bold pr-2 text-md">Approx</p>
            <p class="text-md font-bold">
              {{ quote.term + " x " + "£ " + formatNumber(quote.payment)}}
            </p>
            <p v-if="quote.balloon != null || quote.balloon > 0" class="font-bold pr-2 text-md">
              &nbsp;+ Balloon £ {{formatNumber(quote.balloon)}} included for month {{ quote.balloon_fall }}
            </p>
          </div>
           <div v-else class="flex">
            <p class="font-bold pr-2 text-md">Approx</p>
            <p class="text-md font-bold">
              {{ quote.term + " x " + "£ " + formatNumber(quote.payment)  + " + VAT (£ "+ formatNumber(0.2*quote.payment) +") "}}
            </p>
          </div>
          <div v-if="quote.vat_deferal" class="flex">
            <p class="font-bold pr-2 text-md">
              VAT Deferral of £ {{formatNumber(quote.vat)}} included for month {{ quote.balloon_fall }}
            </p>
          </div>
        </div>
        <div class="my-4 text-2xl">
          <p class="italic">
            <span class="font-medium">* </span>Please note that the above is
            subject to full credit and terms may change.
          </p>
          <p class="mt-5" style="line-height: 20px">
            If you would like to proceed or have any questions please contact us
            on
            <a href="tel:${quote.brand.email}">{{ quote.brand.telephone }}</a>
            Where one of the team will be more than happy to help.
          </p>
        </div>
      </div>
      <div class="mt-20 w-5/12">
        <p class="text-lg font-semibold">Yours sincerely</p>
        <img class="h-20" src="/img/signature2.png" alt="" />
        <p class="my-4 text-md font-bold">{{ quote.brand.name }}</p>
      </div>
    </div>
    <div class="footer text-center mt-10 absolute bottom-6">
      <p style="font-size: 0.6em" class="font-light">
        {{ quote.brand.name }} is a credit broker and not a lender. Finance is
        available subject to status. Terms & Conditions apply. Indemnities may
        be required. We work with a number of carefully selected credit
        providers who may be able to offer you finance. Commission will be
        received. We are only able to offer finance products from these
        providers. Our registered office is
        {{ quote.brand.address_line_1 }} RH121EH, FCA 798352.
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BrandService from "../../services/af-quote/BrandService";
import { mapGetters } from "vuex";

export default {
  name: "pdf",
  props: ["with_monthly", "monthly_history", "quote", "image_brand"],
  methods: {
    formatNumber(x) {
      x = parseFloat(x);

      let nf = new Intl.NumberFormat("en-UK", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      nf.resolvedOptions().minimumFractionDigits = 2;
      return nf.format(x);
    },
    date(value) {
      return moment(value).format("MMMM DD, yyyy");
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/authUser",
    }),
    totalNetCost:function(){
      var not_vat_items = parseFloat(this.quote.not_vat_items);
      var cost = parseFloat(this.quote.cost);
      console.log(not_vat_items+cost);
      return this.formatNumber(not_vat_items+cost);
    },
  }
};
</script>
